import React from 'react';
import { Card, CardContent, Typography, Grid, TextField, FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';

const btnSx = { fontWeight: 600, letterSpacing: 0.5 };

const DashboardFilters = ({
  dateFrom,
  dateTo,
  teamFilterId,
  teams = [],
  onDateFromChange,
  onDateToChange,
  onTeamChange,
  onApply,
  onClearFilters,
  showTeam = true,
  onTeamOpen,
  teamsLoading = false,
}) => {
  const hasActiveFilters = !!(dateFrom || dateTo || (showTeam && teamFilterId));
  return (
  <Card sx={{ mb: 3, boxShadow: 2, border: '1px solid', borderColor: 'divider' }}>
    <CardContent>
      <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2 }}>
        Filters
      </Typography>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6} md={showTeam ? 3 : 4}>
          <TextField
            label="Date from"
            type="date"
            size="small"
            fullWidth
            value={dateFrom}
            onChange={(e) => onDateFromChange(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={showTeam ? 3 : 4}>
          <TextField
            label="Date to"
            type="date"
            size="small"
            fullWidth
            value={dateTo}
            onChange={(e) => onDateToChange(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        {showTeam && (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl size="small" fullWidth>
              <InputLabel>Team</InputLabel>
              <Select
                value={teamFilterId}
                label="Team"
                onChange={(e) => onTeamChange(e.target.value)}
                onOpen={onTeamOpen}
                disabled={teamsLoading && !teams.length}
              >
                <MenuItem value="">All teams</MenuItem>
                {teams.map((t) => (
                  <MenuItem key={t.id} value={t.id}>
                    {t.name ?? t.title ?? t.id}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
        <Grid item xs={12} sm={showTeam ? 6 : 12} md={showTeam ? 3 : 4} sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
          <Button variant="contained" onClick={onApply} sx={{ ...btnSx, textTransform: 'uppercase', bgcolor: '#154A8A', '&:hover': { bgcolor: '#0d3a6a' } }}>
            Apply
          </Button>
          {onClearFilters && (
            <Button variant="outlined" onClick={onClearFilters} startIcon={<FilterListOffIcon />} disabled={!hasActiveFilters} sx={{ ...btnSx, textTransform: 'uppercase', borderColor: '#154A8A', color: '#154A8A' }}>
              Remove filter
            </Button>
          )}
        </Grid>
      </Grid>
    </CardContent>
  </Card>
  );
};

export default DashboardFilters;
